var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modalContents__object10",
      attrs: { "data-modalContents": "thanks02" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row no-gutters" }, [
          _c(
            "div",
            { staticClass: "col-lg-7 col-md-8 col-10 mx-auto row no-gutters" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-8 mx-auto" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-center globalModal--btn",
                    attrs: { href: "javascript:void(0);" },
                    on: { click: _vm.reload }
                  },
                  [_vm._v("戻る")]
                )
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "col-12 text-center" }, [
      _c("strong", [_vm._v("会員データ変更が完了しました。")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20b6b069", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20b6b069","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/vue/component/modal/mypage_edit_thanks.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-20b6b069","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/vue/component/modal/mypage_edit_thanks.vue
// module chunks = 0